import React from 'react';
import { ETSY_SHOP_URL } from '../../lib/constants';

interface PillarTagProps {
  children: React.ReactNode;
}

const PillarTag: React.FC<PillarTagProps> = ({ children }) => (
  <span className="bg-green-600 text-white text-xs font-medium px-2.5 py-1 rounded">
    {children}
  </span>
);

const ProductsSection: React.FC = () => (
  <section className="bg-slate-800 text-white py-20 px-6">
    <div className="max-w-7xl mx-auto">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
        Choose Your Megadish
      </h2>
      <p className="text-lg text-slate-400 text-center mb-12 max-w-2xl mx-auto">
        Both products protect, share, and multiply. Only the dish extends range.
      </p>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Compact */}
        <div className="bg-slate-700 rounded-2xl p-8 grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-6 items-center">
          <div className="w-full h-40 bg-slate-600 rounded-xl flex items-center justify-center text-slate-400 text-sm text-center px-4">
            Photo of Compact<br/>version coming soon
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-2">Megadish Compact</h3>
            <div className="flex flex-wrap gap-2 mb-3">
              <PillarTag>Protect</PillarTag>
              <PillarTag>Share</PillarTag>
              <PillarTag>Multiply</PillarTag>
            </div>
            <p className="text-slate-400 text-sm mb-4 leading-relaxed">
              Pocket-sized security. Perfect when you don't need extra range — 
              trains, planes, hotels, cafés. Small enough for your bag.
            </p>
            <a
              href={ETSY_SHOP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-5 py-2.5 rounded-lg font-semibold text-sm transition-colors"
            >
              View on Etsy
            </a>
          </div>
        </div>

        {/* Dish */}
        <div className="bg-slate-700 rounded-2xl p-8 grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-6 items-center">
          <img 
            src="/BeachImage2.jpg" 
            alt="Megadish with dish antenna" 
            className="w-full h-40 object-cover rounded-xl"
          />
          <div>
            <h3 className="text-2xl font-semibold mb-2">Megadish</h3>
            <div className="flex flex-wrap gap-2 mb-3">
              <PillarTag>Protect</PillarTag>
              <PillarTag>Share</PillarTag>
              <PillarTag>Extend</PillarTag>
              <PillarTag>Multiply</PillarTag>
            </div>
            <p className="text-slate-400 text-sm mb-4 leading-relaxed">
              The full package. When you need to reach distant WiFi — 
              beach from hotel, boat from shore, pitch from campsite office.
            </p>
            <a
              href={ETSY_SHOP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-5 py-2.5 rounded-lg font-semibold text-sm transition-colors"
            >
              View on Etsy
            </a>
          </div>
        </div>
      </div>
      
      <p className="text-center text-slate-500 text-xs mt-6">
        📸 Photo shows early prototype. Production units are smaller and sleeker.
      </p>
    </div>
  </section>
);

export default ProductsSection;
